import {connect, useSelector} from "react-redux";
import React, {useRef, useState} from "react";
import {getCkProductBrandMappingList, getDailyStoreSaleReport} from "../../../../api/api";
import {
    CAlert,
    CButton,
    CCol,
    CForm, CFormInput,
    CInputGroup,
    CInputGroupText,
    CNav,
    CNavItem,
    CNavLink, CTabContent,
    CTabPane
} from "@coreui/react";
import {Loading} from "../../../../components/common";
import ProductBrandMapping from "./ProductBrandMapping";
import ProductBrandMultiMapping from "./ProductBrandMultiMapping";
import ProductBrandMappingExcel from "./ProductBrandMappingExcel";

const ProductBrandMappingManagement = (props) => {
    const { user } = useSelector((props) => props.account);
    const [activeKey, setActiveKey] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});

    return (
        <>
            {loading ? <Loading/> : null}
            {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
            <div className="d-grid gap-1 d-md-flex justify-content-between" style={{ marginBottom: 10 }}>
                <h5>판매상품-외부브랜드 코드 연결</h5>
            </div>
            <CNav variant="tabs" role="tablist">
               {/* <CNavItem>
                    <CNavLink
                        active={activeKey === 1}
                        onClick={() => setActiveKey(1)}>외부 브랜드 상품코드 매핑(1개)</CNavLink>
                </CNavItem>*/}
                <CNavItem>
                    <CNavLink
                        active={activeKey === 1}
                        onClick={() => setActiveKey(1)}>외부 브랜드 상품코드 매핑</CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink
                        active={activeKey === 2}
                        onClick={() => setActiveKey(2)}>엑셀 일괄등록</CNavLink>
                </CNavItem>
            </CNav>
            <CTabContent>
                {/*<CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 1}>
                    <div style={{height: 10}}/>
                    <ProductBrandMapping user={user} onLoading={setLoading} onError={setError} />
                </CTabPane>*/}
                <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 1}>
                    <div style={{height: 10}}/>
                    <ProductBrandMultiMapping user={user} onLoading={setLoading} onError={setError} />
                </CTabPane>
                <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 2}>
                    <div style={{height: 10}}/>
                    <ProductBrandMappingExcel user={user} onLoading={setLoading} onError={setError} />
                </CTabPane>
            </CTabContent>
        </>
    );
}

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductBrandMappingManagement);